import React from "react";
import styled from "styled-components";
import BtnIcon from "./Btn/BtnIcon";
import ZoomController from "./ZoomController";
import { useCameraZoom } from "Provider/HomeProvider";

const Wrapper = styled.div``;
const Col = styled.div``;

const ZoomWrapper = styled(Col)`
	position: relative;
	display: flex;
	justify-content: center;
	margin: 12px 0;
`;
const ZoomBar = styled.div`
	background-color: ${(props) => props.theme.color.white};
	width: 1px;
	height: ${(props) => `${props.theme.size.zoom.bar}px`};
`;

const Controller = styled(ZoomController)`
	position: absolute;
	width: ${(props) => `${props.theme.size.zoom.bar + props.theme.size.zoom.controller * 1.5}px`};
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%) rotate(-90deg);
`;

const Zoom: React.FC<{ className?: string }> = ({ className }) => {
	const { value, onChange, setValue } = useCameraZoom();

	const handlePluseClick = () => {
		setValue((n) => n + 1);
	};
	const handleMinusClick = () => {
		setValue((n) => n - 1);
	};

	return (
		<Wrapper className={className}>
			<Col>
				<BtnIcon icon="pluse" onClick={handlePluseClick} />
			</Col>
			<ZoomWrapper>
				<ZoomBar />
				<Controller onChange={onChange} value={value} />
			</ZoomWrapper>
			<Col>
				<BtnIcon icon="minus" onClick={handleMinusClick} />
			</Col>
		</Wrapper>
	);
};

export default Zoom;
